import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.updateImageDisplay()
  }

  setMode(event) {
    const mode = event.target.value
    this.updateImageDisplay(mode)
  }

  updateImageDisplay(mode = null) {
    // Get current mode from radio button if not provided
    if (!mode) {
      const checkedRadio = document.querySelector('input[name="image_mode"]:checked')
      mode = checkedRadio ? checkedRadio.value : 'fill'
    }

    // Find all image elements and update their object-fit
    const images = document.querySelectorAll('.image-display')
    images.forEach(img => {
      if (mode === 'fit') {
        img.classList.remove('object-cover')
        img.classList.add('object-contain')
      } else {
        img.classList.remove('object-contain')
        img.classList.add('object-cover')
      }
    })
  }
}